import { ParsedUrlQuery } from 'querystring';

import { alertBannerDismissedPlugin } from './plugins/alert-banner-dismissed';
import { disableFeaturePlugin } from './plugins/disable-feature';
import { extractPath } from '@sitecore-content-sdk/nextjs/utils';
import { multisitePlugin } from './plugins/multisite';
import { personalizePlugin } from './plugins/personalize';

const plugins = [
  multisitePlugin,
  alertBannerDismissedPlugin,
  disableFeaturePlugin,
  personalizePlugin,
];

export interface Plugin {
  /**
   * A function which will be called during path extraction
   */
  exec(path: string): string;
}

export class PathExtractor {
  /**
   * Extract normalized Sitecore item path
   * @param {ParsedUrlQuery} [params]
   */
  public extract(params: ParsedUrlQuery | undefined): string {
    if (params === undefined) {
      return '/';
    }
    let path = extractPath({ params });

    // Ensure leading '/'
    if (!path.startsWith('/')) {
      path = '/' + path;
    }

    const extractedPath = (Object.values(plugins) as Plugin[]).reduce(
      (resultPath, plugin) => plugin.exec(resultPath),
      path
    );

    return extractedPath;
  }
}

export const pathExtractor = new PathExtractor();
